import { render } from "./customerProfile.vue?vue&type=template&id=4d0b9fbc&scoped=true"
import script from "./customerProfile.vue?vue&type=script&lang=js"
export * from "./customerProfile.vue?vue&type=script&lang=js"

import "./customerProfile.vue?vue&type=style&index=0&id=4d0b9fbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0b9fbc"]])

export default __exports__